module.exports = __webpack_public_path__ + "static/img/demo-right.59b49a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo-right.png
// module id = Csap
// module chunks = 1